import React, { useState } from 'react';

// Components
import { WpGif, WpGifPicker, WpGifPickerDropdown } from '../';
import { WpButton } from '../../button';
import { WpIcon } from '../../icon';

const GifPickerDocs = () => {
  const Default = () => {
    return (
      <>
        <h5 className="mb-2">Default Gif Picker</h5>
        <WpGifPicker />
      </>
    );
  };

  const WithInitialSearchValue = () => {
    return (
      <>
        <h5 className="mt-5 mb-2">With initial search value</h5>
        <p>
          Changes the initial search term to display specific gif when loaded, here &quot;rock star&quot; is passed in
        </p>
        <WpGifPicker initialSearchTerm="rock star" />
      </>
    );
  };

  const Dropdown = () => {
    const [gif, setGif] = useState(null);

    return (
      <>
        <h5 className="mt-5 mb-2">As dropdown</h5>
        <p>
          Changes the initial search term to display specific gif when loaded, here &quot;rock star&quot; is passed in
        </p>
        <WpGifPickerDropdown
          initialSearchTerm="rock star"
          withStyling={false}
          withBoxShadow={true}
          initialOpen
          onSelect={setGif}
          placement="top-end"
        >
          <WpButton>
            <WpIcon name="smile" />
          </WpButton>
        </WpGifPickerDropdown>

        {gif && (
          <>
            <br />
            You selected:
            <br />
            <div style={{ width: '300px' }}>
              <WpGif url={gif.images.fixed_width.url} />
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <>
      <Default />
      <WithInitialSearchValue />
      <Dropdown />
    </>
  );
};

export default GifPickerDocs;
